import type {BioIconProps} from '../common-types'

export function SortingArrowsIcon({fill = 'black', ...attributes}: BioIconProps) {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M6.59524 6.59524L9.64286 9.72438L12.6905 6.59524M6.59524 3.54762L3.54762 0.5M3.54762 0.5L0.5 3.54533M3.54762 0.5V9.64286M9.64286 0.5V9.64286"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
